<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="dialog = true"
          />
        </v-col>
        <v-col cols="12" CustomPageActions v-if="user.hq">
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-2 align-center">
              <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                <v-autocomplete
                  :items="resource.countries"
                  v-model="selectedCountry"
                  :label="i18n.country"
                  autocomplete="disabled"
                  outlined
                  hide-details
                  :disabled="!user.hq"
                  dense
                  clearable
                  @change="filterWACount()"
                  item-value="id"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  <template v-slot:selection="{ attr, on, item, selected }">
                    <span
                      v-bind="attr"
                      :input-value="selected"
                      v-on="on"
                      :class="`${arabic?'arFont':'enFont'}`"
                    >
                      <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <span
                      :class="`${arabic?'arFont':'enFont'}`"
                    >
                      {{i18n[item.slug]}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                <v-autocomplete
                  :items="resource.programs"
                  v-model="selectedProgram"
                  :label="i18n.program"
                  autocomplete="disabled"
                  outlined
                  hide-details
                  clearable
                  dense
                  @change="filterWACount()"
                  item-value="id"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  <template v-slot:selection="{ attr, on, item, selected }">
                    <span
                      v-bind="attr"
                      :input-value="selected"
                      v-on="on"
                      :class="`${arabic?'arFont':'enFont'}`"
                    >
                      <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <span
                      :class="`${arabic?'arFont':'enFont'}`"
                    >
                      {{i18n[item.slug]}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromDate"
                      label="From Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      dense
                      @change="filterWACount()"
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    @change="filterWACount()"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toDate"
                      label="To Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      @change="filterWACount()"
                      dense
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    @change="filterWACount()"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                <span class="font-weight-bold pr-3">{{counter.total}}</span>
                <span>msg</span>
              </v-col>
              <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                <span class="font-weight-bold pr-3">{{counter.reminders}}</span>
                <span>reminder</span>
              </v-col>
              <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                <v-btn color="success" :loading="loading"  @click.native="sendManualReminders()" v-if="user.role == 'master' || user.role == 'superadmin'">Send Reminders</v-btn>
                <span class="text-xs ml-2">{{ sentRemindersCount }} reminders sent</span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-expansion-panels focusable>
                <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
                  <v-expansion-panel-header>
                    <v-row class="pa-0 align-center">
                      <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`">
                        <div>{{r.country_name.slug}}</div>
                      </v-col>
                      <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`">
                        <div>{{r.program_name.slug}}</div>
                      </v-col>
                      <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-left`">
                        <v-switch @change="updateResource(r)" 
                          hide-details 
                          :class="`${arabic?'arFont':'enFont'}`" 
                          :name="i18n.active"
                          :label="i18n.active" v-model="r.active"></v-switch>
                      </v-col>
                      <v-col cols="11" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-left`">
                        <div>{{r.sent}} message</div>
                      </v-col>
                      <v-col cols="11" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-left`">
                        <div>{{r.confirm_reminders_sent}} reminder</div>
                      </v-col>
                      <v-col cols="1" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-center`">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-avatar
                                size="10"
                                :color="r.active?'success':'error'"
                              >
                              </v-avatar>
                            </span>
                          </template>
                          <div :class="`${arabic?'arFont':'enFont'}`">{{getFormat(r.updated_at)}}</div>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-divider class="pb-3"></v-divider>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
        <multiDialog
          :dialog="dialog"
          :loading="loading"
          :resourceSettings="resourceSettings"
          :deleting="deleting"
          :resourceKeys="resourceKeys"
          :newResource="newResource"
          @closeDialog="()=>{dialog = false;newResource={};}"
          @deleteResource="deleteResource"
          @updateResource="updateResource"
          @postResource="postResource"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging, multiDialog },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
      },
      resourceKeys:[
        { name: 'country_id', label:'country', type:'select', items:'countries', source:'db', data:[], required:true },
        { name: 'program_id', label:'program', type:'select', items:'programs', source:'db', data:[], required:true },
        { name: 'active', label:'active', type:'switch', required:true },
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:true,
        pagination:true,
      },
      newResource:{},
      programs:[],
      countries:[],
      roles:[],
      selectedCountry:null,
      selectedProgram:null,
      menu1:false,
      menu2:false,
      fromDate:null,
      toDate:null,
      counter:{},
      sentRemindersCount:0
    }
  },
  
  methods: {
    async sendManualReminders() {
      this.loading = true;
      const sent = await axios.get('https://aramccocrm.com/api/v1/autoconfirm-patrol').then(x=>x.data)
      if(sent && sent.leads) {
        this.sentRemindersCount = sent.leads
      }
      this.loading = false

    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items)
            console.log(this.resource[f.items])
            f.data = this.resource[f.items].map(x=>{
              return {
                ...x,
                text:x.name?x.name:x.en?x.en:'unknown',
                [`${f.name}_id`]:x.id
              }
            })
          }
          res(true)
        })()
      })
    },
    validate(newResource) {
      return true
    },
    getItems(items) {
      return this[items]
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    buildFilter(){
      let filter = ``
      if(this.selectedCountry) {
        filter += `&filter[country_id]=${this.selectedCountry}`
      }
      if(this.selectedProgram) {
        filter += `&filter[program_id]=${this.selectedProgram}`
      }
      if(this.fromDate && this.toDate) {
        filter += `&filter[from]=${this.fromDate}&filter[to]=${this.toDate}`
      }
      return filter
    },
    async filterWACount(){
      await this.loadWACount()
    },
    async loadWACount() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        this.counter = await this.$store.dispatch('getResource', {resource:'/waofficial-counters?' + this.buildFilter()})
        this.loading = false
        res()
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/waofficial'})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/waofficial' + '/search', value:this.search})
        }
        this.loading = false
        res()
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/waofficial', page:`?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/waofficial' + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:'/waofficial' + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
    
        console.log(r)
        await this.$store.dispatch('putResource', {resource:'/waofficial' + `/${r.id}`, value:r})
        this.loadResource()
        this.loading = false
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:'/waofficial' + `/${r.id}`})
        this.loadResource()
        this.loading = false
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(r)
        await this.$store.dispatch('postResource', {resource:'/waofficial', value:r})
        this.loadResource()
        this.loading = false
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
    this.loadItems()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>